import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { i18n as I18n } from 'utils/i18n';

// hooks
import useIsMobile from '../../hooks/useIsMobile';

// components
import Page from '../page';
import LandingPage from '../landingPage';
import RoomTypesExplainer from '../roomTypesExplainer';

const RoomsPage = ({
  roomType,
  roomCategory,
  title,
  headerDescription,
  headerTitle,
}) => {
  const [backgroundImage, setBackgroundImage] = useState('');
  const isMobileView = useIsMobile();

  useEffect(() => {
    const backgroundImageUrl = isMobile => {
      const viewSuffix = isMobile ? '-mobile' : '';
      return `url('../images/landing/${roomType.replace(
        '_',
        '-'
      )}-room${viewSuffix}.jpeg')`;
    };

    setBackgroundImage(backgroundImageUrl(isMobileView));
  }, [isMobileView, roomType]);

  return (
    <>
      <Page title={headerTitle} description={headerDescription}>
        <div
          className="banner room-type-banner"
          style={{
            backgroundImage,
          }}
          data-cy="roomTypeLandingPage"
        >
          <div className="inner">
            <LandingPage
              heading={I18n.t(`room_types_landing_page.${roomType}.heading`)}
              subHeading={I18n.t(
                `room_types_landing_page.${roomType}.subHeading`
              )}
              roomType={title}
              pathname={`/book-${roomType}-rooms`}
              locationPlaceholder={I18n.t(
                `room_types_landing_page.${roomType}.location_placeholder`
              )}
            />
          </div>
        </div>
        <RoomTypesExplainer
          heading={I18n.t(
            `room_types_landing_page.${roomType}.explainer.heading`
          )}
          intro={I18n.t(`room_types_landing_page.${roomType}.explainer.intro`)}
          roomCategory={roomCategory}
          displayExplainerItemText={false}
          wrapImageWithLink
          wrapHeadingWithLink
        />
      </Page>
    </>
  );
};

RoomsPage.propTypes = {
  roomType: PropTypes.string.isRequired,
  roomCategory: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default RoomsPage;
